import React from 'react'
import { Route } from "react-router-dom";
import Header from "../components/Headers/Header";
import Footer from "../components/Footers/Footer";
import Loading from "../pages/Loading/Loading";

const HomeLayout = (props) => {
    const style = {
        display:"flex",
        flexDirection:"column"
    }
    return(
        <div style={style}>
            {/* <Loading /> */}
            <Header />
            <div >
                {props.children}
            </div>        
            <Footer/>
        </div>
    )
}

export default function HomeTemplate({ Component, ...props }) {
    return (
        <Route
            {...props}
            render = {propsComponent => (
                <HomeLayout>
                    <Component {...propsComponent} />
                </HomeLayout>
            )}
        /> 
    )
}
